export default {
    'payment.title': '支付',
};